/**
 * Theme Constants
 * Font family declarations and non-MUI brand colour tokens.
 * Referenced by theme.config.ts and globalStyles.ts.
 */

export { fontFamilyConstants } from "@sage/sage-network-shared-ui/shared-constants";

export const NonMuiColors = Object.freeze({
  BLACK: "#000000",
  BLACK_ALPHA_0: "rgba(0, 0, 0, 0.00)",
  WHITE: "#FFFFFF",
  SAGE_GREEN: "#007E45",
  SAGE_GREEN_RGB: "rgb(0 126 69)",
  BOX_SHADOW_COLOR: "rgba(0, 0, 0, 0.10)",
  BOX_SHADOW_COLOR_DARKER_SHADE: "rgba(0, 0, 0, 0.15)",
  BOX_SHADOW_COLOR_DARKER_SHADE2: "rgba(0, 0, 0, 0.20)",
  OVERLAY_BACKDROP: "rgba(0, 0, 0, 0.6)",
  BOX_SHADOW_OVERLAY_BACKDROP_DOUBLE: "rgba(0, 0, 0, 0.12)",
  HEADER_GREY: "#1A1A1A",
  IN_APP_HOVER: "#004D2A",
  TOOLBAR_GREY: "#4D4D4D",
  GREY_94: "#F0F0F0",
  FOCUS_VISIBLE_COLOR: "#1D4ED8",
  FOCUS_VISIBLE_COLOR_TRANSLUCENT: "rgba(41, 98, 255, 0.5)",
  DARK_ORANGE: "#BF360C",
  SCHEMATIC_NEUTRAL_200: "#CCD6DB",
  SCHEMATIC_NEUTRAL_500: "#335B70",
  GREEN_LINEAR:
    "linear-gradient(90deg, var(--colors-brand-In-App-Default, #007E45) 0%, var(--colors-brand-Brilliant, #00D639) 100.43%)",
  BRAND_SECONDARY: "#005C16",
  BRAND_SECONDARY_HOVER: "#004711"
});
